const reviewData = [
  {
    name: "Dylan T. ",
    content: (
      <div>
        Working with Christian Wade from Concierge Wellness is a
        game-changer for me. From our very first session, it was clear that
        Christian isn't just any physical therapist, he genuinely cares about
        his clients and goes above and beyond to offer solutions tailored to
        individual needs. The cash payment option simplified things for me,
        removing the usual insurance-related stress. What truly touched me was
        Christian's willingness to travel and ensure I was comfortable in my own
        environment. Beyond his exceptional skills, Christian has an incredible
        way of explaining complex concepts. He broke everything down, ensuring I
        understood every step of my treatment. I can't express enough how
        grateful I am for Christian's dedication and expertise. If you're
        considering physical therapy, look no further than Concierge Wellness.
      </div>
    ),
  },
  {
    name: "Katie D.",
    content: `Christian is very professional, kind, and knowledgeable. From setting up the very first appointment, 
    I could tell that he genuinely cares about his clients lives and overall wellbeing and doesn’t just try to get 
    them in and out the door. He helped me with an ankle injury, and even though I had to do my meetings over zoom, 
    I felt more comfortable and taken care of with him than the people that I tried to see in-person. We met virtually, 
    and Christian was able to give me at-home exercises that were helpful and healing, and he was very intentional with 
    asking questions and understanding exactly where I’m at even when he couldn’t be there in person. 
    If I ever have any injuries again, Christian will for sure be the first person I call to set up PT.`,
  },
  {
    name: "Keiriel N.",
    content: `Christian, DPT has been awesome from the beginning of my treatment. Listens to my concerns and what I feel like needs 
    to be better or what is going well and he always has my best interest in mind. Works towards my goals and always has 
    patient-centered care. He is personable and meets me where I am every day I am there. 
    Pushes me to do better within my limits and is always encouraging. 
    I have never felt judgment coming in if I hadn't met my goal or got behind on my workouts. He is just as encouraging and 
    understanding. I'm so thankful he has been my PT!!!`,
  },
  {
    name: "Kelli L.",
    content: (
      <div>
        Christian was my first point of contact after a stress fracture in my
        foot. As an active person and avid trail runner, I was itching to get
        back to training as soon as possible and I wouldn't have been able to do
        it without Christian's guidance and expertise. He pinpointed some
        weaknesses and gave me recommendations and exercises to correct
        imbalances so that I would rehab correctly. Christian recommended Dry
        Needling for my knee, and even though I was a little nervous about it (I
        mean, needles, come on) the relief was almost immediate. He also talked
        to other running specialists and PTs to help him make the best decisions
        about my rehab. Plus, he made it very easy to schedule and he provides
        in-home treatment. He's clearly committed to patient care and learning
        as much as he can about his field!
      </div>
    ),
  },
  {
    name: "Priscilla D.",
    content: `Doctor Wade has helped me and one of my adult children - both virtually. Christian gave me exercises to 
     strengthen my ankle after I broke it with a fall. He helped me get back on the ski slopes through 
    strength training and stretching. The movement in my left foot/ankle now matches the right (which is a HUGE improvement).
     More importantly, Christian helped our daughter with a foot injury she had overseas. He treated her virtually (over zoom). 
     It was such a blessing to her to have Christian’s care and expertise and he definitely helped her strengthen and heal. 
     While some doctors indicated surgery might be needed, Christian insisted she be patient and persistent with her exercises. 
     It worked! I highly recommend Dr Wade. If you can’t meet with him in person, he will virtually find a way to help.`,
  },
  {
    name: "Shane M.",
    content: `Christian got me in within 2 days after an injury and had a very flexible schedule. He was very professional and 
    documented everything that we did, gave me take home exercises to complete and provided me a receipt for my HSA (along with
       a very fair price). If I ever need assistance again I will 100% be back. He also had some great overall tips on diet and 
       exercise as well.
    `,
  },
];

export default reviewData;
